import { css, styled } from 'styled-components'

export const StyledPageBackground = styled.div<{
  $topColor: string
  $bottomColor: string
}>`
  position: fixed;
  z-index: -1;
  top: ${({ theme }) => theme.sizes.headerHeight}rem;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    180deg,
    ${({ $topColor }) => $topColor} 5%,
    ${({ $bottomColor }) => $bottomColor} 95%
  );
  pointer-events: none;
`

export const StyledPageCorner = styled.div<{
  $color: string
  $position: 'top' | 'bottom'
}>`
  position: fixed;
  left: 0;
  width: 100%;
  height: 1rem;
  background: ${({ $color }) => $color};
  ${({ $position }) => {
    if ($position === 'bottom') {
      return css`
        bottom: 0;
      `
    }
    return css`
      top: 0;
    `
  }};
`
